const INSTAGRAM = 'https://www.instagram.com';

//sanitize username in case there is still an @
export const getIGUsernameLink = (username: string) => `${INSTAGRAM}/${username?.replace('@', '')}`;

const getIGUsernameTags = (text: string) => {
    if (!text) return [];

    const tagsCandidates = Array.from(text.matchAll(RegExp(/@((-|\.)?\w)+/, 'g')), (match) => ({
        length: match[0].length,
        link: getIGUsernameLink(match[0]),
        name: match[0],
        offset: match.index
    }));

    // Filter tags preceded by a char (like mail addresses)
    return tagsCandidates.filter(({ offset }) => 0 === offset || ' ' === text[offset - 1]);
};

export default getIGUsernameTags;
